import { NgModule } from '@angular/core';
import { BookingComponent } from './booking.component';
import { BookingRouting } from './booking.routing';
import { BookingMainModule } from 'app_sasha/shared/components/booking-main/booking-main.module';
import { SashaBreadcrumbModule } from 'app_sasha/shared/components/breadcrumb/sasha-breacrumb.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';

@NgModule({
    imports: [
        BookingRouting,
        BookingMainModule,
        SashaBreadcrumbModule,
        TitleServiceModule,
    ],
    exports: [BookingComponent],
    declarations: [BookingComponent],
    providers: [],
})
export class BookingModule { }
